import { IDisplayColumn } from '../../record-view/model/model';
import { IProcess } from './element.service';
import { Options, CustomStepDefinition } from 'ng5-slider';
export enum CTType {
	// CTTypeInput å½å¥
	Input = 'I',
	// CTTypeSelect åé
	Select = 'S',
	// CTTypeSlider èå´éæ©
	Slider = 'SL',
	// CTTypeMultiSelect å¤é
	MultiSelect = 'MS',
	// CTTypeRangeInput èå´å½å¥
	RangeInput = 'RI'
}
export interface RecordViewParam {
	DB: string;
	Sql: string;
	ManualPage: boolean; // æ¯å¦æå·¥åé¡µï¼æå·¥åé¡µå°ç¨templateæ¸²æsqlï¼èä¸ä¼åµå¥sqlè¿è¡åé¡µ
	TableName: string;
	UniqueField: string[];
	Columns: IDisplayColumn[];
	Processes: IProcess[];
	AllColumns: {
		Name: string;
		Type: string;
	}[];
	ConditionalTemplates: ConditionalTemplate[];
}
export interface ConditionalTemplate {
	Type: CTType;
	Field: string;
	Setting: any;
}
// Option åä¸ªéé¡¹
export interface Option {
	Text: string;
	Value: string;
}

// CTSelectSetting åéçè®¾ç½®
export interface CTSelectSetting {
	Options: Option[];
	OtherOption: string; // å¶ä»éé¡¹çéé¡¹å¼
}

// CTSliderSetting åéçè®¾ç½®
export interface CTSilderSetting {
	Min: number;
	Max: number;
	Step?: number;
	EnforceStep: boolean; // åªè½éæ©æ æ³¨ç¹
	PositiveInfinity: boolean; // æ¾ç¤ºæ­£æ ç©·ç¹
	NegativeInfinity: boolean; // æ¾ç¤ºè´æ ç©·ç¹
	LabelTemplate: string; // æ ç­¾æ¨¡æ¿
	Ratio: number; // æ¢ç®æ¯ä¾ï¼æ°æ®æäº¤å°æ°æ®åºè¿è¡æ¯è¾æ¶ï¼éè¦æ¢ç®çç³»æ°
}
export class SilderSetting {
	constructor(public data: CTSilderSetting) {
		this.translate = this.translate.bind(this);
	}
	static defaultOptions(): Options {
		return {
			floor: 0,
			ceil: 100,
			draggableRange: true
		};
	}
	translate(val: number) {
		if (this.data.PositiveInfinity && this.data.Max === val) {
			return 'â';
		}
		if (this.data.NegativeInfinity && this.data.Min === val) {
			return '-â';
		}

		if (this.data.LabelTemplate) {
			return this.data.LabelTemplate.replace('${val}', `${val}`);
		}
		return `${val}`;
	}
	toOptions(): Options {
		const rev = {
			floor: this.data.Min ? this.data.Min : 0,
			ceil: this.data.Max ? this.data.Max : 100,
			draggableRange: true,
			translate: this.translate
		} as Options;
		if (this.data.Step) {
			if (this.data.EnforceStep) {
				rev.step = this.data.Step;
			} else {
				rev.tickStep = this.data.Step;
			}
			rev.showTicks = true;
		}
		return rev;
	}
}
// CTMultiSelectSetting å¤éçè®¾ç½®
export interface CTMultiSelectSetting {
	Options: Option[];
	OtherOption: string; // å¶ä»éé¡¹çéé¡¹å¼
}

// CTRangeInputSetting èå´è¾å¥è®¾ç½®
export interface CTRangeInputSetting {
	LowLabel: string;
	HighLabel: string;
}
